import htmx from 'htmx.org'
class Component {
  init() {
    htmx.process(document.body)
  }
}

export default new Component()
